<script setup lang="ts">
import { type BeforeItem, useBreadcums } from './BreadcrumsLine.vue'

const t2 = useT2({})
const { myLink } = useLinks()

const props = defineProps<{
  max?: boolean
  classMain?: string | None
  title?: stringI18n | None
  breadcrums?: (() => BeforeItem[]) | None
}>()

const breadcums = useBreadcums(() => {
  return {
    nolast: true,
    before: [{ title: t2('Home'), to: myLink('index', {}) }, { title: t2('Customer Care'), to: myLink('info', {}) }, ...helpers.arr(props.breadcrums?.())],
  }
})

if (import.meta.server) {
  useSeoBreadcums(() => {
    return { hidden: [], list: breadcums.value, pagename: props.title }
  })
}
</script>

<template>
  <main :class="$style.a" class="_h100p _wm100p m_wmin0 d_wmin280">
    <div class="d_hm100vh d_sticky" :class="[$style.a0, !max && $style.a3, classMain, $clsClass('AppMenu')]">
      <slot name="top" />
      <div v-if="title" :class="[$style.top]" class="_col _gap06 m_pl1 m_pr1 m_pb2 d_pb4 d_pl1">
        <BreadcrumsLine v-memo="[breadcums]" :list="breadcums" :pagename="title" />
        <h1 class="m_pb4 d_pb8">{{ title }}</h1>
        <slot name="content" />
      </div>
      <slot />
    </div>
  </main>
</template>

<style module>
:global(.d) .a0 {
  top: 0;
  display: flex;
  flex-direction: column;
}

.a3 {
  composes: global(d_pl1);
  composes: global(d_pr1);
  composes: global(d_mla);
  composes: global(d_mra);
}

:global(.d) .a3 {
  max-width: 800px;
}

:global(.d) .top {
  padding-top: calc(var(--page-top) + 20px);
}
</style>
